import { DashboardFilterModel } from "Dashboard/models/DashboardFilterModel";
import { DashboardViewModel } from "Dashboard/models/DashboardViewModel";
import { createContext } from "react";

export interface DashboardContextProps {
  query: DashboardFilterModel;
  setQuery: (query: DashboardFilterModel) => void;
  resetQuery: () => void;
  isLoading: boolean;
  results: DashboardViewModel[] | undefined;
  getMeetingsUrl: (boardName: string) => string;
}

export const DashboardContext = createContext({} as DashboardContextProps);
